export default {
    state: {
        menuTop: 0, // 右击菜单显示位置（视口坐标）
        menuLeft: 0,
        menuShow: false,
        pasteCanvasTop: 0, // 右键点击位置对应的画布坐标，用于粘贴
        pasteCanvasLeft: 0,
    },
    mutations: {
        showContextMenu(state, { top, left, pasteCanvasTop, pasteCanvasLeft }) {
            state.menuShow = true
            state.menuTop = top
            state.menuLeft = left
            if (typeof pasteCanvasTop === "number") {
                state.pasteCanvasTop = pasteCanvasTop
            }
            if (typeof pasteCanvasLeft === "number") {
                state.pasteCanvasLeft = pasteCanvasLeft
            }
        },

        hideContextMenu(state) {
            state.menuShow = false
        },

        setPasteCanvasPoint(state, { left, top }) {
            if (typeof left === "number") {
                state.pasteCanvasLeft = left
            }
            if (typeof top === "number") {
                state.pasteCanvasTop = top
            }
        },
    },
}